import { apiSlice } from "../api/apiSlice";

export const quizMarksApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getQuizMarks: builder.query({
            query: () => `/quizMark`,
        }),

        getQuizMark: builder.query({
            query: (id) => `/quizMark?id=${id}`,
        }),
        getQuizMarkByStudent: builder.query({
            query: ({ studentId, videoId }) => `/quizMark?student_id=${studentId}&video_id=${videoId}`,
        }),

        addQuizMarks: builder.mutation({
            query: (data) => ({
                url: "/quizMark",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const res = await queryFulfilled;
                    if (res?.data?.id) {
                        dispatch(
                            apiSlice.util.updateQueryData("getQuizMarks", undefined, draft => {
                                draft.push(res?.data)
                            })
                        )
                    }
                } catch (err) {

                }
            },
        })
    }),
});

export const {
    useGetQuizMarkQuery,
    useGetQuizMarksQuery,
    useAddQuizMarksMutation,
    useGetQuizMarkByStudentQuery
} = quizMarksApi;
